import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthInterceptor } from './auth.interceptor';
import { FirebaseAuthService } from './firebase-auth.service';
import { PdfCacheService } from './pdf-cache.service';
import { PlanReviewerService } from './plan-reviewer.service';

/** Keeps shared plan and PDF caches scoped to the current Firebase session. */
@Injectable({ providedIn: 'root' })
export class AuthScopedCacheService {
  private readonly auth = inject(FirebaseAuthService);
  private readonly planReviewer = inject(PlanReviewerService);
  private readonly pdfCache = inject(PdfCacheService);

  constructor() {
    let previousUser: unknown = Symbol('no-auth-emission');
    this.auth.user$.pipe(takeUntilDestroyed()).subscribe(user => {
      if (user === previousUser) return;
      if (previousUser && typeof previousUser === 'object') AuthInterceptor.clearAuthFailure(previousUser);
      previousUser = user;
      this.planReviewer.clearPlanDataCache();
      this.pdfCache.clearParsedPdfCache();
    });
  }
}
